import { PairingResponse } from '@yaak/components/services/api/api'

export const displayWaitingPairingRequests = (
  waitingPairingRequests?: PairingResponse
) =>
  waitingPairingRequests?.metaData?.totalCount &&
  waitingPairingRequests?.metaData?.totalCount > 0
    ? waitingPairingRequests?.metaData?.totalCount?.toString()
    : undefined
